import { getActionLog, clearActionLog } from '../middleware/actionLogger';
import { getPlayerId } from './playerId';
import { screenDimensions } from './deviceInfo';

const fetch = require("node-fetch");

// Owns the two backend "a joke happened" beacons Layout fires (joke
// shown, then solved-and-moved-on) plus the bookkeeping they need:
// deduping repeat joke_started pings for the same joke, and tracking how
// long the tab was hidden mid-solve so that time isn't counted as real
// solving time. One instance per Layout, created once in its constructor
// and reused across every joke in the session.
export class ActionLogTracker {
  constructor() {
    this.last_started_joke_id = null;
    // cumulative time the tab's been hidden during the joke currently in
    // progress - reset whenever a genuinely new joke starts, read (and
    // finalized) when a solve is actually logged
    this.hidden_seconds = 0;
    this.hidden_since = null;
  }

  // call from a 'visibilitychange' listener
  handle_visibility_change(){
    if (document.hidden){
      this.hidden_since = Date.now();
    } else if (this.hidden_since){
      this.hidden_seconds += (Date.now() - this.hidden_since) / 1000;
      this.hidden_since = null;
    }
  }

  compute_hidden_seconds(){
    let total = this.hidden_seconds;
    if (document.hidden && this.hidden_since){
      total += (Date.now() - this.hidden_since) / 1000;
    }
    return total;
  }

  // tells the backend a joke was actually shown to this player, so
  // completion rate (used to order jokes) can be measured as finishes
  // over starts - a joke the player abandons otherwise leaves no trace
  // at all, since flush() only ever fires on solve.
  joke_started(joke_id){
    if (joke_id == null || joke_id === this.last_started_joke_id){
      return;
    }
    this.last_started_joke_id = joke_id;
    this.hidden_seconds = 0;
    this.hidden_since = null;
    fetch('/api/joke_started', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ joke: joke_id, player: getPlayerId(), ...screenDimensions() }),
    }).catch(() => {
      //best-effort logging - a failed/offline request shouldn't block gameplay
    });
  }

  // posts the logged redux actions for the joke just solved, alongside
  // the scramble order it started from and how long solving actually took
  flush({ joke_id, shuffled_words, time_to_next_seconds }){
    const actions = getActionLog();
    clearActionLog();
    if (!actions.length){
      return;
    }
    // set once per joke (see jokeReducer.fresh_joke_state) and never
    // mutated afterward - this is still exactly the scramble the player
    // was first shown, not whatever order they filled it in
    const starting_word_order = shuffled_words.map(word => word.order);
    const hidden_seconds = this.compute_hidden_seconds();
    fetch('/api/log_actions', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        joke: joke_id, player: getPlayerId(), actions, time_to_next_seconds, starting_word_order,
        hidden_seconds, ...screenDimensions(),
      }),
    }).catch(() => {
      //best-effort logging - a failed/offline request shouldn't block gameplay
    });
  }
}
